import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioCapsen } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_CAPSEN: TIdToPageConfigMap = {
  [PageIdStylioCapsen.AGE_CAPSEN]: {
    id: PageIdStylioCapsen.AGE_CAPSEN,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioCapsen.URGE_CAPSEN]: {
    id: PageIdStylioCapsen.URGE_CAPSEN,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsen.HAIR_COLOR_CAPSEN]: {
    id: PageIdStylioCapsen.HAIR_COLOR_CAPSEN,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.EYES_COLOR_CAPSEN]: {
    id: PageIdStylioCapsen.EYES_COLOR_CAPSEN,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.JEWELRY_CAPSEN]: {
    id: PageIdStylioCapsen.JEWELRY_CAPSEN,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.BODY_SHAPE_CAPSEN]: {
    id: PageIdStylioCapsen.BODY_SHAPE_CAPSEN,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.STYLIO_TO_HELP_CAPSEN]: {
    id: PageIdStylioCapsen.STYLIO_TO_HELP_CAPSEN,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.TALL_CAPSEN]: {
    id: PageIdStylioCapsen.TALL_CAPSEN,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.WEIGHT_CAPSEN]: {
    id: PageIdStylioCapsen.WEIGHT_CAPSEN,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.URGE_2_CAPSEN]: {
    id: PageIdStylioCapsen.URGE_2_CAPSEN,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsen.FEEL_ABOUT_CAPSEN]: {
    id: PageIdStylioCapsen.FEEL_ABOUT_CAPSEN,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.PERCENTAGE_CAPSEN]: {
    id: PageIdStylioCapsen.PERCENTAGE_CAPSEN,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.SHOPPING_CAPSEN]: {
    id: PageIdStylioCapsen.SHOPPING_CAPSEN,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.STYLE_MOST_MATTERS_CAPSEN]: {
    id: PageIdStylioCapsen.STYLE_MOST_MATTERS_CAPSEN,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.FAVORITE_COLORS_CAPSEN]: {
    id: PageIdStylioCapsen.FAVORITE_COLORS_CAPSEN,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.LIKE_OR_DISLIKE_12_CAPSEN]: {
    id: PageIdStylioCapsen.LIKE_OR_DISLIKE_12_CAPSEN,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.LIKE_OR_DISLIKE_13_CAPSEN]: {
    id: PageIdStylioCapsen.LIKE_OR_DISLIKE_13_CAPSEN,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.LIKE_OR_DISLIKE_14_CAPSEN]: {
    id: PageIdStylioCapsen.LIKE_OR_DISLIKE_14_CAPSEN,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.LIKE_OR_DISLIKE_15_CAPSEN]: {
    id: PageIdStylioCapsen.LIKE_OR_DISLIKE_15_CAPSEN,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.LIKE_OR_DISLIKE_16_CAPSEN]: {
    id: PageIdStylioCapsen.LIKE_OR_DISLIKE_16_CAPSEN,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.LIKE_OR_DISLIKE_17_CAPSEN]: {
    id: PageIdStylioCapsen.LIKE_OR_DISLIKE_17_CAPSEN,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.LIKE_OR_DISLIKE_18_CAPSEN]: {
    id: PageIdStylioCapsen.LIKE_OR_DISLIKE_18_CAPSEN,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.LIKE_OR_DISLIKE_19_CAPSEN]: {
    id: PageIdStylioCapsen.LIKE_OR_DISLIKE_19_CAPSEN,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.STYLES_FEEL_LIKE_YOU_CAPSEN]: {
    id: PageIdStylioCapsen.STYLES_FEEL_LIKE_YOU_CAPSEN,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.URGE_4_CAPSEN]: {
    id: PageIdStylioCapsen.URGE_4_CAPSEN,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsen.BRAND_CAPSEN]: {
    id: PageIdStylioCapsen.BRAND_CAPSEN,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.FIND_NEW_CLOTHES_CAPSEN]: {
    id: PageIdStylioCapsen.FIND_NEW_CLOTHES_CAPSEN,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.NOTHING_TO_WEAR_CAPSEN]: {
    id: PageIdStylioCapsen.NOTHING_TO_WEAR_CAPSEN,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.OLD_CLOTHES_CAPSEN]: {
    id: PageIdStylioCapsen.OLD_CLOTHES_CAPSEN,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.COMBINE_CLOTHES_CAPSEN]: {
    id: PageIdStylioCapsen.COMBINE_CLOTHES_CAPSEN,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.OPTIMIZE_BUDGET_CAPSEN]: {
    id: PageIdStylioCapsen.OPTIMIZE_BUDGET_CAPSEN,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCapsen.URGE_3_CAPSEN]: {
    id: PageIdStylioCapsen.URGE_3_CAPSEN,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsen.PREPARE_FLOW_CAPSEN]: {
    id: PageIdStylioCapsen.PREPARE_FLOW_CAPSEN,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsen.EMAIL_CAPSEN]: {
    id: PageIdStylioCapsen.EMAIL_CAPSEN,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsen.EMAIL_CONSENT_CAPSEN]: {
    id: PageIdStylioCapsen.EMAIL_CONSENT_CAPSEN,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCapsen.SUBSCRIPTIONS_CAPSEN]: {
    id: PageIdStylioCapsen.SUBSCRIPTIONS_CAPSEN,
  },
  [PageIdStylioCapsen.CANCEL_OFFER_CAPSEN]: {
    id: PageIdStylioCapsen.CANCEL_OFFER_CAPSEN,
  },
  [PageIdStylioCapsen.SUB_UPSELL_CAPSEN]: {
    id: PageIdStylioCapsen.SUB_UPSELL_CAPSEN,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsen.UPSELL_CAPSEN]: {
    id: PageIdStylioCapsen.UPSELL_CAPSEN,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCapsen.DOWNLOAD_CAPSEN]: {
    id: PageIdStylioCapsen.DOWNLOAD_CAPSEN,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
